module.exports = __webpack_public_path__ + "static/img/success.92968fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bargain/success.png
// module id = 8SkO
// module chunks = 1